module.exports = __webpack_public_path__ + "static/img/telegram.dcfbe4d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/telegram.svg
// module id = bGdH
// module chunks = 1